import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { ERROR_CODES, ErrorDCR } from '@ddt-web/config';

@Injectable({ providedIn: 'root' })
export class PartnerErrorHelper {
	constructor(
		private contentService: ContentService
	) { }

	/**
	 * Checks the errorCodes and throws error to be handled by the PartnerErrorHandlerSevice.
	 * If error code is INVALID_TOKEN, it throws an INVALID_TOKEN error, otherwise it sends an error with the provided message.
	 *
	 * @responseJson the error response
	 * @message the error message to be handled by the PartnerErrorHandlerSevice
	 */
	public handleResponseError(responseJson: any, message: string): void {
		if (responseJson.errors && responseJson.errors.some(error => error.code.includes(ERROR_CODES.INVALID_TOKEN))) {
			throw new Error(this.contentService.get('PARTNER_INVALID_TOKEN_ERROR', ErrorDCR.PARTNER_INVALID_TOKEN_ERROR));
		} else {
			throw new Error(message);
		}
	}

	public createErrorObject(id: string): any {
		return {
			success: false,
			id: id,
			error: `Object with id: ${id} not found.`
		};
	}
}
